/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PartNumberChangesDetailSolutionComponent} from './part-number-changes-detail-solution.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputModule} from '../../shared/input/input.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {PartNumberChangesNewPartNumberModule} from './part-number-changes-new-part-number/part-number-changes-new-part-number.module';
import {PartNumberChangesAdditionalInputModule} from '../shared/part-number-changes-additional-input/part-number-changes-additional-input.module';
import { PartNumberChangesChangePlantPopupComponent } from './part-number-changes-change-plant-popup/part-number-changes-change-plant-popup.component';
import {LoadingSpinnerModule} from "../../shared/loading/loading-spinner/loading-spinner.module";
import {WarningsModule} from "../../shared/warnings/warnings.module";

@NgModule({
    declarations: [PartNumberChangesDetailSolutionComponent, PartNumberChangesChangePlantPopupComponent],
    imports: [
        CommonModule,
        InputModule,
        PipesModule,
        PartNumberChangesNewPartNumberModule,
        PartNumberChangesAdditionalInputModule,
        LoadingSpinnerModule,
        WarningsModule
    ],
    exports: [PartNumberChangesDetailSolutionComponent]
})
export class PartNumberChangesDetailSolutionModule {
}
